import {isClient} from '@/utils/isTerminal.js'
// app 版本号
export function getVersion() {
    if (!isClient) return;
    let appVersionInfo =  window.navigator.userAgent.match(/NurseFuel\/(\S+)\(\S*\)/i);
    let versionStr = Array.isArray(appVersionInfo) ? appVersionInfo[1] : '';
    return versionStr.replace('+', '');
}


/**
 * 对比字符串版本号的大小，返回1则v1大于v2，返回-1则v1小于v2，返回0则v1等于v2
 * @param {string} v1 当前版本
 * @param {string} v2 要比较的版本
 */
export function versionCompare(v1, v2) {
    let GTR = 1; //大于
    let LSS = -1; //小于
    let EQU = 0; //等于
    let v1arr = String(v1).split(".").map(function (a) {
        return parseInt(a);
    });
    let v2arr = String(v2).split(".").map(function (a) {
        return parseInt(a);
    });
    let arrLen = Math.max(v1arr.length, v2arr.length);
    let result;

    //排除错误调用
    if (v1 == undefined || v2 == undefined) {
        // throw new Error();
        return LSS;
    }

    //检查空字符串，任何非空字符串都大于空字符串
    if (v1.length == 0 && v2.length == 0) {
        return EQU;
    } else if (v1.length == 0) {
        return LSS;
    } else if (v2.length == 0) {
        return GTR;
    }

    //循环比较版本号
    for (let i = 0; i < arrLen; i++) {
        result = loopComp(v1arr[i], v2arr[i]);
        if (result == EQU) {
            continue;
        } else {
            break;
        }
    }
    return result;

    function loopComp(n1, n2) {
        if (typeof n1 != "number") {
            n1 = 0;
        }
        if (typeof n2 != "number") {
            n2 = 0;
        }
        if (n1 > n2) {
            return GTR;
        } else if (n1 < n2) {
            return LSS;
        } else {
            return EQU;
        }
    }
}

/***
 * 版本比较
 * @param version
 * @return {Number} 1 当前版本大于比较版本； 0 等于； -1 小于比较版本
 */
export function compareCurrentVersion(version) {
    return versionCompare(getVersion(), version);
}

/**
 * 版本比较，满足版本返回true
 * @param version
 * @returns {boolean}
 * @constructor
 */
export function VersionVerification(version) {
    return versionCompare(getVersion(), version) >= 0;
    // return versionCompare('5.0.6', version) >= 0;
}

/**
 * 版本比较，大于当前版本则返回true
 * @param version
 * @returns {boolean}
 * @constructor
 */
export function VersionGreater(version) {
  return versionCompare(getVersion(), version) > 0;
  // return versionCompare('5.0.6', version) >= 0;
}